import { useState, useEffect, useContext } from "react";
import { Widget } from "./components/Widget";
import { nanoid } from "nanoid";
import useAsyncFn from "src/hooks/useAsyncFn";
import { ChatService } from "../service";
import { SENDER_TYPE, TRACKING_TYPE } from "src/constant";
import "./style.css";
import tracking from "src/hooks/useTracking";
import { v4 as uuidv4 } from "uuid";
import { SettingContext } from "src/context/settings";

const sessionId = uuidv4();
export const WidgetContainer = () => {
    const { settings, chatbotId } = useContext(SettingContext);
    const [messages, setMessages] = useState([]);
    const [messageFromAPI, getMessageFromAPI] = useAsyncFn(
        ChatService.postChatbot
    );

    useEffect(() => {
        tracking(TRACKING_TYPE.ACCESS, { sessionId: sessionId, chatbotId: chatbotId });

        return () => {
            tracking(TRACKING_TYPE.CLOSE, { sessionId: sessionId, chatbotId: chatbotId });
        };
    }, []);

    useEffect(() => {
        if (settings.greeting && messages.length === 0) {
            setMessages(
                messages.concat({
                    id: nanoid(),
                    message: settings.greeting,
                    content: settings.greeting,
                    role: "assistant",
                    sender: "remote",
                    direction: "incoming",
                    // position: "single"
                })
            );
        }
    }, [settings.greeting, messages]);

    useEffect(() => {
        const data = messageFromAPI?.value?.data;
        // console.log("data", data);
        if (data) {
            const response = data.response;
            const newMessage = [
                {
                    id: nanoid(),
                    message: response,
                    content: response,
                    role: "assistant",
                    sender: SENDER_TYPE.REMOTE,
                    direction: "incoming",
                    relevantDocs: data.relevantDocs && data.relevantDocs.length > 0 ? data.relevantDocs : false,
                    // position: "single"
                },
            ];
            let list = messages.concat(newMessage);
            setMessages(list);
        }
    }, [messageFromAPI?.value]);

    const handleSend = (messageData) => {
        messageData = messageData.replace(/&nbsp;/g, ' ');
        // console.log(messageData)
        const newMessage = {
            id: nanoid(),
            message: messageData,
            content: messageData,
            role: "user",
            sender: SENDER_TYPE.ME,
            direction: "outgoing",
            // position: "single"
        };

        setMessages([...messages, newMessage]);

        if (messages.length === 0) {
            const prefixMessage = {
                role: "assistant",
                content: settings.greeting
            }
            getMessageFromAPI(
                chatbotId,
                {
                    messages: [...messages, prefixMessage, newMessage],
                    sessionId: sessionId,
                });
        } else {
            getMessageFromAPI(
                chatbotId,
                {
                    messages: [...messages, newMessage],
                    sessionId: sessionId,
                });
        }

        tracking(TRACKING_TYPE.COMMENT, {
            msg: messageData,
            sessionId: sessionId,
        });
    };

    return (
        <Widget
            isLoading={messageFromAPI?.loading}
            messages={messages}
            onSend={handleSend}
            setMessages={setMessages}
            sessionId={sessionId}
        />
    );
};
